export default __webpack_public_path__ + "static/media/PopSugar.3f4140d3.svg";